import React, { useState, useEffect } from "react";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import  { setUser } from  "../../state/reducers/authReducer.js"
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import axios from "../../utils/axios-interceptor";
import "./Login.scss";
import { updateLoadingMessage } from "../../state/reducers/common";


const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginResponse, setLoginResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [validationMessages, setValidationMessages] = useState({});
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      setShowDisclaimer(true);
    }
  }, [isLoggedIn]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setLoginResponse(null);
    const validationErrors = {};

    if (!username) {
      validationErrors.username = "Username is required";
    }
    if (!password) {
      validationErrors.password = "Password is required";
    }

    if (Object.keys(validationErrors).length > 0) {
      setValidationMessages(validationErrors);
      setIsLoading(false);
      return;
    }

    try {
      dispatch(updateLoadingMessage({
        message: "Logging in..."
      }))
      const response = await axios.get("/login", {
        params: { username, password }
      });

      if (response.data.message.includes("Logged in successfully!")) {
        const userData = {
          username: response.data.user.username,
          fullname: response.data.user.fullname,
          email: response.data.user.email,
          role: response.data.user.role || "user", // Default to 'user' if role is null
          daily_token_allowance: response.data.user.daily_token_allowance
        };
        
        dispatch(setUser(userData));
        
        console.log("Login successful - User data:", userData);
        
        setShowDisclaimer(true);
      } else {
        setLoginResponse(response.data);
      }
    } catch (error) {
      setLoginResponse({
        message: "An error occurred. Please try again."
      });
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDisclaimerClose = () => {
    setShowDisclaimer(false);
    navigate("/live-testing");
  };

  return (
    <div className="page-wrapper login-page">
      <div className="left-panel">
        <img src="./images/login-img.png" alt="" className="login-img" />
      </div>
      <div className="right-panel">
        <div className="login-wrapper">
          <div className="login-page-title text-center">
            <h2>Welcome Back</h2>
            <div className="logo-wrapper justify-content-center d-flex">
              <img src="./images/ust_logo.svg" alt="" className="ust-logo me-3" />
              <h1>Code Crafter</h1>
            </div>
          </div>
          <div className="login-panel justify-content-center">
            <form className="login-form">
              <Row className="mb-3">
                <Col xs={12}>
                  <InputField 
                    key='username' 
                    type='text' 
                    label="Username" 
                    value={username} 
                    id='username'
                    onChange={(e) => {
                      setUsername(e.target.value);
                      setValidationMessages({ ...validationMessages, username: "" });
                    }}
                    layoutStyle="vertical"
                    placeholder="Enter your username"
                    required
                    validationMsg={validationMessages.username}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={12}>
                  <InputField 
                    key='password' 
                    type='password' 
                    label="Password" 
                    value={password} 
                    id='password'
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setValidationMessages({ ...validationMessages, password: "" });
                    }}
                    layoutStyle="vertical"
                    placeholder="Enter your password."
                    required
                    validationMsg={validationMessages.password}
                  />
                </Col>
              </Row>
              {loginResponse && (
                <Row className="mb-3">
                  <Col xs={12}>
                    <Alert className="message" variant={loginResponse.message.includes("Logged in successfully!") ? "success" : "danger"}>
                      {loginResponse.message}
                    </Alert>
                  </Col>
                </Row>
              )}
              <Row className="justify-content-center">
                <Col>
                  <CustomButton 
                    label={isLoading ? "Logging in..." : "Login"} 
                    type="submit"
                    disabled={isLoading}
                    onClick={handleLogin}
                    className="login-btn" 
                  />
                </Col>
              </Row>
            </form>
          </div>
          <div className="register mt-2">
            <div>New here? <Link to="/register">Register now.</Link></div>
            <div><Link to="/forgotPassword">Forgot Password</Link></div>
          </div>
        </div>
      </div>
      <Modal show={showDisclaimer} onHide={handleDisclaimerClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Disclaimer for using UST CodeCrafter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>UST CodeCrafter is not the end-all-be-all solution for code and platform conversion. The tool requires human intervention to ensure the accuracy and completeness of the conversion process. This version of UST CodeCrafter is a trial and does not provide fine-tuning or iterative capabilities for all programming languages at this point.</p>
          <p>Please note that while certain language conversions have been iterated and fine-tuned for optimal results, other conversions have not undergone the same level of testing. Consequently, conversions for these untested languages may not yield optimal results. </p>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton label="I Understand" onClick={handleDisclaimerClose} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LoginPage;